import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef } from "@angular/material/legacy-dialog";
import { CtButtonConfiguration, MAT_RAISED_PRIMARY, MAT_RAISED_WARN } from "@ctsolution/ct-framework";
import { TranslateService } from '@ngx-translate/core';

/**
 * Risultato del dialog di conferma duplicato
 */
export interface CompanyDuplicateConfirmationResult {
  confirmed: boolean;
}

/**
 * Componente per la modale di conferma quando si tenta di creare/modificare
 * una company con codice fiscale o partita IVA già esistenti nel sistema
 */
@Component({
  selector: 'app-company-duplicate-confirmation-dialog',
  templateUrl: './company-duplicate-confirmation-dialog.component.html',
  styleUrls: ['./company-duplicate-confirmation-dialog.component.scss']
})
export class CompanyDuplicateConfirmationDialogComponent implements OnInit {

  /** Configurazione del pulsante di conferma */
  confirmButton!: CtButtonConfiguration;

  /** Configurazione del pulsante di annullamento */
  cancelButton!: CtButtonConfiguration;

  constructor(
    private dialogRef: MatLegacyDialogRef<CompanyDuplicateConfirmationDialogComponent>,
    private translateService: TranslateService
  ) {}

  /**
   * Inizializzazione del componente
   * Configura i pulsanti con le traduzioni
   */
  ngOnInit(): void {
    this.initializeButtons();
  }

  /**
   * Inizializza i pulsanti con le etichette tradotte
   */
  private initializeButtons(): void {
    
    // Configurazione del pulsante di conferma
    this.confirmButton = CtButtonConfiguration
      .create()
      .setLabel(this.translateService.instant('CT_PAGE.CT_FORM.confirm') || 'Conferma')
      .setAction(() => this.onConfirm())
      .setMatherialOptions(MAT_RAISED_PRIMARY);

    // Configurazione del pulsante di annullamento
    this.cancelButton = CtButtonConfiguration
      .create()
      .setLabel(this.translateService.instant('CT_PAGE.CT_FORM.cancel') || 'Annulla')
      .setAction(() => this.onCancel())
      .setMatherialOptions(MAT_RAISED_WARN);
  }

  /**
   * Gestisce la conferma dell'operazione
   * L'utente ha confermato di voler procedere nonostante il duplicato
   */
  onConfirm(): void {
    const result: CompanyDuplicateConfirmationResult = {
      confirmed: true
    };
    this.dialogRef.close(result);
  }

  /**
   * Gestisce l'annullamento dell'operazione
   * L'utente ha deciso di non procedere con la creazione/modifica
   */
  onCancel(): void {
    const result: CompanyDuplicateConfirmationResult = {
      confirmed: false
    };
    this.dialogRef.close(result);
  }
}
